import React from "react";

class Asset extends React.Component {
    constructor(props) {
        super(props);

        this.onError = this.onError.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    onError(e) {
      e.target.src = "/htmldata/images/games/no.jpg";
    }

    onClick(e) {
      this.props.openGamePopup(this.props.base, this.props.item);
    }

    render() {
      if (this.props.item) {
          const {id, label, col, bcol} = this.props.item;
          const s ={ "color": col || "#fff", "backgroundColor": bcol || "#000"};

          return (<div key={label} className={"menuItem_"+ this.props.base}>
            <div className="inner">
              <div className="cover" onClick={e => this.onClick(e)}>
                  <img onError={this.onError} src={"/htmldata/images/games/" + this.props.base + id + ".jpg"} alt="cover"></img>
              </div>
            </div>
            <div className={"titleGame_"+ this.props.base}>
                <div className={"idGame_"+ this.props.base} style={s}>{id}</div>
                <div className="txtGame" dangerouslySetInnerHTML={{__html: label}}></div>
              </div>
          </div>);
      }
      else return <div></div>
    }
}

export default Asset;
